"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../constants/index.js");
var _getAdobeLaunch = _interopRequireDefault(require("./getAdobeLaunch"));
var _getDefaultSetup = _interopRequireDefault(require("./getDefaultSetup"));
var _loadAdobeLaunch = _interopRequireDefault(require("./loadAdobeLaunch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propertyBrands = _index.brandValues.propertyBrands;
var state = {
  defaultValues: undefined,
  formatters: undefined,
  setup: (0, _getDefaultSetup["default"])(),
  init: function init(_ref) {
    var _ref2, _setup$brand, _setup$adobeLaunch;
    var defaultValues = _ref.defaultValues,
      formatters = _ref.formatters,
      setup = _ref.setup;
    var adobeLaunch = (0, _getAdobeLaunch["default"])(setup === null || setup === void 0 ? void 0 : setup.adobeLaunch);
    this.defaultValues = defaultValues;
    this.formatters = formatters;
    this.setup.adobeLaunch = adobeLaunch;
    this.setup.brand = (_ref2 = (_setup$brand = setup === null || setup === void 0 ? void 0 : setup.brand) !== null && _setup$brand !== void 0 ? _setup$brand : propertyBrands[adobeLaunch.property]) !== null && _ref2 !== void 0 ? _ref2 : this.setup.brand;

    // Use incoming setup object for condition to avoid loading Adobe Launch from default values
    if (setup !== null && setup !== void 0 && (_setup$adobeLaunch = setup.adobeLaunch) !== null && _setup$adobeLaunch !== void 0 && _setup$adobeLaunch.env) (0, _loadAdobeLaunch["default"])(adobeLaunch);
  },
  reset: function reset() {
    this.defaultValues = undefined;
    this.formatters = undefined;
    this.setup = (0, _getDefaultSetup["default"])();
  }
};
var _default = exports["default"] = state;